import React from 'react';
import { Box } from '@wix/design-system';
export const Header = ({ logo, className, dataHook, height, background, children, }) => {
    return (React.createElement(Box, { className: className, dataHook: dataHook, height: height, minHeight: "42px", width: "100%", verticalAlign: "middle", background: background, padding: "0 12px", boxSizing: "border-box" },
        logo && React.createElement(Box, null, logo),
        children));
};
//# sourceMappingURL=Header.js.map